define('views/content/leads',['require','views/base/list_page_view','views/components/lead/leads','collections/leads','text!templates/content/leads.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var LeadsView = require('views/components/lead/leads');
    var LeadsCollection = require('collections/leads');

    var temp = require("text!templates/content/leads.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'leads-page',
        titleKey: 'leads',

        setCollection: function () {
            this.collection = new LeadsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new LeadsView({
                collection: this.collection
            }));
        }
    });
});
